import { render, staticRenderFns } from "./Planificador.vue?vue&type=template&id=1844c2f1&scoped=true&"
import script from "./Planificador.vue?vue&type=script&lang=js&"
export * from "./Planificador.vue?vue&type=script&lang=js&"
import style0 from "./Planificador.vue?vue&type=style&index=0&id=1844c2f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1844c2f1",
  null
  
)

export default component.exports